module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst additionalAttributes = []\nconst additionalClasses = []\nconst additionalStyles = []\nconst tooltips = config.tooltips || {}\nif(config.usage){\nadditionalClasses.push(`usage_${config.usage}`)\n}\nif(additionalClasses.length > 0){\nadditionalAttributes.push(`class=\"${additionalClasses.join(' ')}\"`)\n}\nconst {\ntitleKey = 'dashboard.elements.title.absence',\ntooltipMessageKey = '',\nicon = '',\nframeColor = '#666666'\n} = config\nif(tooltipMessageKey){\ntooltips.head = tooltips.head || {}\ntooltips.head.messageKey = tooltipMessageKey\n}\nif(frameColor){\nadditionalStyles.push(`--controller-bg-color: ${frameColor};`)\n}\nif(additionalStyles.length > 0){\nadditionalAttributes.push(`style=\"${additionalStyles.join(' ')}\"`)\n}\n%><div <%- additionalAttributes.join(' ') %>><%\n%><section class=\"head\"><%\nif (tooltips.head) {\n%><div class=\"tooltip\"><%- include('../../../../base/tooltip/tooltip', { model: tooltips.head }); %></div><%\n}\n%><div class=\"title\"><%\nif(icon){\n%><i class=\"<%= icon %>\"></i><%\n}\n%><%- storage.__(titleKey) %><%\n%></div><%\n%><div class=\"controls\"><%\n%><%#- include('../../../core/form/elements/buttons/default', { formMapping: { buttonType: 'close', context: 'stats', symbolOnly: true, preventTabIndex: true } }); %><%\n%></div><%\n%></section><%\n%><%- helpers.renderSection('additionalContentRight') %><%\n%><section class=\"content\"><%\nif(config.showTopGranted){\n%><section class=\"top\"><%\n%><%- helpers.renderSection('topLeft') %><%\n%><%- helpers.renderSection('topRight') %><%\n%></section><%\n}\n%><%- helpers.renderSection('bottom') %><%\n%></section><%\n%></div>"
  , __filename = "components/templates/office/dashboard/element/controller.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const additionalAttributes = []
const additionalClasses = []
const additionalStyles = []
const tooltips = config.tooltips || {}
if(config.usage){
additionalClasses.push(`usage_${config.usage}`)
}
if(additionalClasses.length > 0){
additionalAttributes.push(`class="${additionalClasses.join(' ')}"`)
}
const {
titleKey = 'dashboard.elements.title.absence',
tooltipMessageKey = '',
icon = '',
frameColor = '#666666'
} = config
if(tooltipMessageKey){
tooltips.head = tooltips.head || {}
tooltips.head.messageKey = tooltipMessageKey
}
if(frameColor){
additionalStyles.push(`--controller-bg-color: ${frameColor};`)
}
if(additionalStyles.length > 0){
additionalAttributes.push(`style="${additionalStyles.join(' ')}"`)
}

    ; __line = 28
    ; __append("<div ")
    ; __append( additionalAttributes.join(' ') )
    ; __append(">")
    ; 

    ; __line = 29
    ; __append("<section class=\"head\">")
    ; 
if (tooltips.head) {

    ; __line = 31
    ; __append("<div class=\"tooltip\">")
    ; __append( include('../../../../base/tooltip/tooltip', { model: tooltips.head }) )
    ; __append("</div>")
    ; 
}

    ; __line = 33
    ; __append("<div class=\"title\">")
    ; 
if(icon){

    ; __line = 35
    ; __append("<i class=\"")
    ; __append(escapeFn( icon ))
    ; __append("\"></i>")
    ; 
}

    ; __line = 37
    ; __append( storage.__(titleKey) )
    ; 

    ; __line = 38
    ; __append("</div>")
    ; 

    ; __line = 39
    ; __append("<div class=\"controls\">")
    ; 

    ; __line = 40
    ; 

    ; __line = 41
    ; __append("</div>")
    ; 

    ; __line = 42
    ; __append("</section>")
    ; 

    ; __line = 43
    ; __append( helpers.renderSection('additionalContentRight') )
    ; 

    ; __line = 44
    ; __append("<section class=\"content\">")
    ; 
if(config.showTopGranted){

    ; __line = 46
    ; __append("<section class=\"top\">")
    ; 

    ; __line = 47
    ; __append( helpers.renderSection('topLeft') )
    ; 

    ; __line = 48
    ; __append( helpers.renderSection('topRight') )
    ; 

    ; __line = 49
    ; __append("</section>")
    ; 
}

    ; __line = 51
    ; __append( helpers.renderSection('bottom') )
    ; 

    ; __line = 52
    ; __append("</section>")
    ; 

    ; __line = 53
    ; __append("</div>")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/office/dashboard/element/controller.ejs

}